import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';

const EasyTransferMessage = (props) => {


  return (
    <div className='easy-transfer-msg'>
      <div className='easy-transfer-msg-img'><Image src={require('../Icons/avatars.svg')} /></div>
      <div className='easy-transfer-msg-text'>
        מעבירים בעלות באתר,<br />
        בכמה צעדים פשוטים ובחינם!
      </div>
    </div >
  );
};



export default EasyTransferMessage;
